import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Row, Col, Button } from 'react-bootstrap';
import { Table } from '@components';
import { UserService, ContactService } from '@services';
import { ConfirmationModal, AddContactModal } from '@components/modals';
import { Loader, Pagination, SearchFieldCached } from '@components/common';
import utils from '@utils';
import { thunks } from '@redux/app';
import staffColumns from './utils/columnDefinition';

class Staff extends Component {
	constructor(props) {
		super(props);

		const { user : { IsStaffAdmin }, USStates, getUSStates } = props;

		// Block this page for non admin users
		if (!IsStaffAdmin) window.location.href = '/';

		if (USStates.length === 0) getUSStates();

		this.state = {
			data              : [],
			rawData           : [],
			displayCount      : 25,
			totalCount        : 0,
			pageNumber        : 1,
			searchQuery       : '',
			loading           : false,
			columnsDefinition : [],
		};
	}

	componentDidMount() {
		this.getStaff();
	}

	getStaff = () => {
		const { user : { Organization : { Id : organizationId } } } = this.props;
		const { searchQuery, pageNumber, displayCount } = this.state;

		this.setState({ loading : true, data : [], rawData : [] });

		ContactService.getAll({
			organizationId,
			pageNumber,
			displayCount,
			search : searchQuery === '' ? undefined : searchQuery,
		})
			.then((response) => {
				const rawData = response.data;
				const data = rawData.ItemList.map((object) => ({
					id    : object.Id,
					name  : { firstName : object.FirstName, lastName : object.LastName },
					phone : utils.formatPhoneNumber(object.MobilePhone),
					email : object.EmailAddress,
				}));

				this.setState({
					rawData,
					data,
					totalCount        : rawData.Count,
					loading           : false,
					columnsDefinition : staffColumns(rawData.Count, this.editMember, this.resetPassword, this.deleteStaff),
				});
			})
			.catch(() => {
				utils.notify({
					type    : 'error',
					message : 'Error loading staff members',
					title   : 'Oops',
				});

				this.setState({ loading : false });
			});
	}

	deleteStaff = (id) => () => {
		this._confirmationModal.openModal({
			title              : 'Delete Staff Member',
			subTitle           : 'Are you sure you want to delete this staff member? Deleting this staff member CANNOT be undone.',
			confirmationButton : 'YES, DELETE STAFF MEMBER',
			onConfirm          : this.performDelete.bind(null, id),
		});
	}

	performDelete = (id) => {
		this.setState({ loading : true });

		ContactService.delete(id)
			.then(() => {
				utils.notify({
					type    : 'success',
					message : 'Staff member successfully deleted',
					title   : 'Success',
				});

				this.getStaff();
			})
			.catch(() => {
				utils.notify({
					type    : 'error',
					message : 'Error deleting contact',
					title   : 'Oops',
				});

				this.setState({ loading : false });
			});
	}

	resetPassword = (email, name) => () => {
		this._confirmationModal.openModal({
			title              : 'Reset Password',
			subTitle           : `Are you sure you want to reset ${name}'s password?`,
			confirmationButton : 'YES, RESET PASSWORD',
			onConfirm          : this.performResetPassword.bind(null, email),
		});
	}

	performResetPassword = (email) => {
		this.setState({ loading : true });

		UserService.resetPassword(email)
			.then(() => {
				this.setState({ loading : false });

				utils.notify({
					type    : 'success',
					message : 'Password successfully reseted',
				});
			})
			.catch(() => {
				this.setState({ loading : false });

				utils.notify({
					type    : 'error',
					message : 'Error reseting the password',
					title   : 'Oops',
				});
			});
	}

	editMember = (Id) => () => {
		const { user : { Organization : { Id : organizationId } } } = this.props;
		const { rawData : { ItemList } } = this.state;
		const originalObject = ItemList.find((item) => item.Id === Id);

		const data = {
			id        : originalObject.Id,
			firstName : originalObject.FirstName,
			lastName  : originalObject.LastName,
			email     : originalObject.EmailAddress,
			phone     : originalObject.MobilePhone,
			address   : originalObject.StreetAddress1,
			city      : originalObject.City,
			state     : originalObject.StateId,
			zipCode   : originalObject.Zipcode,
			isAdmin   : originalObject.IsAdmin,
			organizationId,
		};

		this._contactModal.openModal(data);
	}

	addContactResponse = () => {
		this.setState({
			loading : true,
		}, this.getStaff);
	}

	handleOnClickAdd = () => {
		const { user : { Organization : { Id : organizationId } } } = this.props;
		this._contactModal.openModal({ organizationId });
	}

	handleOnPaginate = (pageNumber) => {
		this.setState({
			pageNumber,
		}, this.getStaff);
	}

	handleOnSearch = (value) => {
		this.setState({
			searchQuery : value,
			pageNumber  : 1,
		}, this.getStaff);
	}

	render() {
		const { state } = this;
		const { user : { IsStaffAdmin }, USStates } = this.props;

		if (!IsStaffAdmin) return null;

		return (
			<Fragment>
				<div className="container padded">
					<div>
						<div className="font-size-30 margin-bottom-40">Staff</div>
						<div className="search-bar">
							<Row>
								<Col sm={4} md={3}>
									<SearchFieldCached
										historyPrefix="staff_search"
										placeholder="Search Staff"
										searchQuery={state.searchQuery}
										onSearch={this.handleOnSearch}
										onClear={this.handleOnSearch}
									/>
								</Col>
								<Col md={2} className="pull-right">
									<Button
										id="add-staff"
										bsStyle="primary"
										onClick={this.handleOnClickAdd}
									>
										+ Add Staff
									</Button>
								</Col>
							</Row>
						</div>
					</div>
					<Table
						columns={state.columnsDefinition}
						data={state.data}
						rowKey="id"
						containerClassName="legacy"
					/>
					<Pagination
						totalCount={state.totalCount}
						displayCount={state.displayCount}
						pageNumber={state.pageNumber}
						onPaginate={this.handleOnPaginate}
						disabled={state.loading}
					/>
				</div>
				<ConfirmationModal ref={(ref) => { this._confirmationModal = ref; }} />
				<AddContactModal
					ref={(ref) => { this._contactModal = ref; }}
					USStates={USStates}
					submittedEvent={this.addContactResponse}
					withIsAdminCheckbox
				/>
				<Loader active={state.loading} />
			</Fragment>
		);
	}
}

const mapStateToProps = ({
	app : {
		user,
		USStates,
	},
}) => ({
	user,
	USStates,
});

const mapDispatchToProps = (dispatch) => ({
	getUSStates : bindActionCreators(thunks, dispatch).getUSStates,
});

Staff.propTypes = {
	USStates    : PropTypes.array,
	getUSStates : PropTypes.func.isRequired,
	user        : PropTypes.object,
};

Staff.defaultProps = {
	USStates : [],
	user     : {},
};

export default connect(mapStateToProps, mapDispatchToProps)(Staff);
